import { action, Action } from 'easy-peasy';
import { MeidouInfoType } from '@meitu/xdesign-widgets/dist/types/meidouInfo';

export interface IMeidouModel {
    meidouInfo: MeidouInfoType | null;
    setMeidouInfo: Action<IMeidouModel, MeidouInfoType>;
}

export const meidouModel: IMeidouModel = {
    meidouInfo: null,
    setMeidouInfo: action((state, meidouInfo) => {
        const { total_amount, available_amount } = meidouInfo;
        state.meidouInfo = { total_amount, available_amount };
    }),
};
